import { AuthContext, Button, Card, FormLowcodeLite, getFormattedLabel } from 'alurkerja-ui'
import { useUiFromSpecContext } from '../../EditorContextProvider'

import clsx from 'clsx'
import { RenderUiFromSpec } from '../../FormRenderer/RenderUiFromSpec'
import React, { useContext } from 'react'
import Swal from 'sweetalert2'
import { AddChildItem } from '../../FormRenderer/AddChildItem'
import { isValidUrl } from '../EditInput/EditInputFields/utils/isValidUrl'

export const RenderP = (props: any) => {
  const className = 'disabled:bg-gray-alurkerja-2'
  return (
    <div className={clsx(className, props.item.className)}>
      <p>{props.item.content}</p>
    </div>
  )
}

export const RenderH1 = (props: any) => {
  const className = ' disabled:bg-gray-alurkerja-2 text-2xl font-semibold'
  return (
    <div className={clsx(className, props.item.className)}>
      <h1>{props.item.content}</h1>
    </div>
  )
}

export const RenderH2 = (props: any) => {
  const className = ' disabled:bg-gray-alurkerja-2 text-xl font-semibold'
  return (
    <div className={clsx(className, props.item.className)}>
      <h2>{props.item.content}</h2>
    </div>
  )
}

export const RenderH3 = (props: any) => {
  const className = ' disabled:bg-gray-alurkerja-2 text-lg font-semibold'
  return (
    <div className={clsx(className, props.item.className)}>
      <h3>{props.item.content}</h3>
    </div>
  )
}

export const RenderH4 = (props: any) => {
  const className = ' disabled:bg-gray-alurkerja-2 text-base font-semibold'
  return (
    <div className={clsx(className, props.item.className)}>
      <h4>{props.item.content}</h4>
    </div>
  )
}

export const RenderH5 = (props: any) => {
  const className = ' disabled:bg-gray-alurkerja-2 text-sm font-semibold'
  return (
    <div className={clsx(className, props.item.className)}>
      <h5>{props.item.content}</h5>
    </div>
  )
}

export const RenderH6 = (props: any) => {
  const className = ' disabled:bg-gray-alurkerja-2 text-xs font-semibold'
  return (
    <div className={clsx(className, props.item.className)}>
      <h6>{props.item.content}</h6>
    </div>
  )
}

export const RenderH = (props: any) => {
  const containsUrl = isValidUrl(props.item.url)
  const { designState } = useUiFromSpecContext()

  if (props.item.heading_type === 'H1') {
    const className = containsUrl ? 'text-[#004B87] text-2xl font-bold' : ' text-2xl font-bold'

    return (
      <div className={clsx(className, props.item.className)}>
        <h1 style={{ color: designState.textColor || '#000000' }}>
          <RenderLinkUnderlined item={props.item} containsUrl={containsUrl} />
        </h1>
      </div>
    )
  }

  if (props.item.heading_type === 'H2') {
    const className = containsUrl ? 'text-[#004B87] text-xl font-bold' : ' text-xl font-bold'

    return (
      <div className={clsx(className, props.item.className)}>
        <h2 style={{ color: designState.textColor || '#000000' }}>
          <RenderLinkUnderlined item={props.item} containsUrl={containsUrl} />
        </h2>
      </div>
    )
  }

  if (props.item.heading_type === 'H3') {
    const className = containsUrl ? 'text-[#004B87] text-lg font-bold' : ' text-lg font-bold'

    return (
      <div className={clsx(className, props.item.className)}>
        <h3 style={{ color: designState.textColor || '#000000' }}>
          <RenderLinkUnderlined item={props.item} containsUrl={containsUrl} />
        </h3>
      </div>
    )
  }

  const className = containsUrl ? 'text-[#004B87]' : ''
  return (
    <div className={clsx(className, props.item.className)}>
      <h1 style={{ color: designState.textColor || '#000000' }}>
        <RenderLinkUnderlined item={props.item} containsUrl={containsUrl} />
      </h1>
    </div>
  )
}

const RenderLinkUnderlined = (props: any) => {
  const { language } = useUiFromSpecContext()

  if (props.containsUrl) {
    return (
      <a href={props.item.url} target={'_blank'} className={clsx('underline', props.item.className)}>
        {getFormattedLabel(props.item.label, language)}
      </a>
    )
  } else {
    return getFormattedLabel(props.item.label, language)
  }
}

export const RenderLink = (props: any) => {
  const className = ''
  return (
    <a href={props.item.url} className={clsx(className, props.item.className)}>
      {props.item.content}
    </a>
  )
}

export const RenderButton = (props: any) => {
  const { item } = props
  const { language } = useUiFromSpecContext()

  return <Button {...item}>{getFormattedLabel(item.content, language)}</Button>
}

export const RenderCard = (props: any) => {
  const { item, inputSize, form, index } = props
  return (
    <Card className={props.className} title={item.title}>
      <>
        <RenderGrid
          key={index}
          item={item}
          xpath={props.xpath + '.' + item.ui_type}
          watch={form.watch}
          children={item.children}
          setValue={form.setValue}
          control={form.control}
          inputSize={inputSize}
        />
      </>
    </Card>
  )
}

export const RenderGrid = (props: any) => {
  const { item } = props
  return (
    <div className={clsx('grid grid-flow-row-dense gap-2 ', item.className)}>
      {props.children.map((child: any, index: number) => {
        return (
          <React.Fragment key={index} >
            <RenderUiFromSpec
              {...props}
              key={index}
              item={child}
              xpath={props.xpath + '.' + index}
              children={child.children}
              form={props.form}
              inputSize={props.inputSize}
              index={0}
              title={''}
              className={undefined}
            />
          </React.Fragment>
        )
      })}
    </div>
  )
}
export const RenderForm = (props: any) => {
  const { watch } = props
  const watchAllFields = watch()

  const axiosInstance = useContext(AuthContext)
  return (
    <>
      <FormLowcodeLite
        className={props.className}
        customForm={() => {
          return props.children.map((child: any, index: number) => {
            return (
              <React.Fragment key={index} >
                <RenderUiFromSpec
                  {...props}
                  key={index}
                  item={child}
                  xpath={props.xpath + '.' + index}
                  children={child.children}
                  form={props.form}
                  inputSize={props.inputSize}
                  index={0}
                  title={''}
                  className={undefined}
                />

                <AddChildItem xpath={props.xpath} index={index}></AddChildItem>
              </React.Fragment>
            )
          })
        }}
        baseUrl={''}
        onSubmit={() => {
          axiosInstance
            .post(props.item.url, watchAllFields)
            .then(() => {
              Swal.fire({
                title: 'Success!',
                text: props.item.success_message ? props.item.success_message : 'Data berhasil disimpan',
                icon: 'success',
                confirmButtonText: 'Ok',
              })
            })
            .catch(() => {
              Swal.fire({
                title: 'Error!',
                text: props.item.error_message ? props.item.error_message : 'Data gagal disimpan',
                icon: 'error',
                confirmButtonText: 'Ok',
              })
            })
        }}
      ></FormLowcodeLite>
    </>
  )
}

export const RenderForm2X3 = (props: any) => {
  const { item } = props
  return (
    <div className={clsx('grid grid-cols-2 gap-3', item.className)}>
      <div className={clsx('w-full flex flex-col gap-3')}>
        {props.children[0] && props.children[0]?.children.length == 0 && (
          <AddChildItem xpath={props.xpath + '.' + '0'}></AddChildItem>
        )}

        {props.children[0] &&
          props.children?.[0]?.children?.map((child: any, index: number) => {
            return (
              <React.Fragment key={index}>
                <RenderUiFromSpec
                  {...props}
                  key={index}
                  item={child}
                  xpath={props.xpath + '.' + '0' + '.' + index}
                  children={child.children}
                  inputSize={props.inputSize}
                  index={0}
                  title={''}
                  form={props.form}
                  className={undefined}
                />

                {props.children?.[0]?.children.length < 2 && (
                  <AddChildItem xpath={props.xpath + '.' + '0'} index={index}></AddChildItem>
                )}
              </React.Fragment>
            )
          })}
      </div>
      <div className={clsx('w-full flex flex-col gap-3')}>
        {props.children[1] && props.children[1]?.children.length == 0 && (
          <AddChildItem xpath={props.xpath + '.' + '1'}></AddChildItem>
        )}

        {props.children[1] &&
          props.children?.[1]?.children?.map((child: any, index: number) => {
            return (
              <React.Fragment key={index}>
                <RenderUiFromSpec
                  {...props}
                  key={index}
                  item={child}
                  xpath={props.xpath + '.' + '1' + '.' + index}
                  children={child.children}
                  inputSize={props.inputSize}
                  index={0}
                  title={''}
                  form={props.form}
                  className={undefined}
                />

                {props.children?.[1]?.children.length < 3 && (
                  <AddChildItem xpath={props.xpath + '.' + '1'} index={index}></AddChildItem>
                )}
              </React.Fragment>
            )
          })}
      </div>
    </div>
  )
}

export const RenderForm2X2 = (props: any) => {
  const { item } = props
  return (
    <div className={clsx('grid grid-cols-2 gap-3', item.className)}>
      <div className={clsx('w-full flex flex-col gap-3')}>
        {props.children[0] && props.children[0]?.children.length == 0 && (
          <AddChildItem xpath={props.xpath + '.' + '0'}></AddChildItem>
        )}

        {props.children[0] &&
          props.children?.[0]?.children?.map((child: any, index: number) => {
            return (
              <React.Fragment key={index}>
                <RenderUiFromSpec
                  {...props}
                  key={index}
                  item={child}
                  xpath={props.xpath + '.' + '0' + '.' + index}
                  children={child.children}
                  form={props.form}
                  inputSize={props.inputSize}
                  index={0}
                  title={''}
                  className={undefined}
                />

                {props.children?.[0]?.children.length < 2 && (
                  <AddChildItem xpath={props.xpath + '.' + '0'} index={index}></AddChildItem>
                )}
              </React.Fragment>
            )
          })}
      </div>
      <div className={clsx('w-full flex flex-col gap-3')}>
        {props.children[1] && props.children[1]?.children.length == 0 && (
          <AddChildItem xpath={props.xpath + '.' + '1'}></AddChildItem>
        )}

        {props.children[1] &&
          props.children?.[1]?.children?.map((child: any, index: number) => {
            return (
              <React.Fragment key={index}>
                <RenderUiFromSpec
                  {...props}
                  key={index}
                  item={child}
                  xpath={props.xpath + '.' + '1' + '.' + index}
                  children={child.children}
                  inputSize={props.inputSize}
                  index={0}
                  title={''}
                  form={props.form}
                  className={undefined}
                />

                {props.children?.[1]?.children.length < 2 && (
                  <AddChildItem xpath={props.xpath + '.' + '1'} index={index}></AddChildItem>
                )}
              </React.Fragment>
            )
          })}
      </div>
    </div>
  )
}

export const RenderDiv = (props: any) => {
  const { item } = props
  const isCol = item.className?.includes('flex-col')

  return (
    <div
      className={clsx('w-full gap-2 flex', isCol ? 'justify-center' : 'items-center', item.className)}
      style={item.style as any}
  
    >
      {props.children && props.children.length == 0 && <AddChildItem xpath={props.xpath}></AddChildItem>}

      {props.children &&
        props.children.map((child: any, index: number) => {
          return (
            <React.Fragment key={"div-"  + index}>
              <RenderUiFromSpec
                {...props}
                key={index}
                item={child}
                xpath={props.xpath + '.' + index}
                children={child.children}
                inputSize={props.inputSize}
                index={0}
                title={''}
                form={props.form}
                className={undefined}
              />

              <AddChildItem xpath={props.xpath} index={index}></AddChildItem>
            </React.Fragment>
          )
        })}
    </div>
  )
}

export const RenderMainDiv = (props: any) => {
  const { item } = props
  const { editor } = useUiFromSpecContext()
  return (
    <div className={clsx('space-y-3 p-6 w-full ', item.className)} style={item.style as any}>
      {props.children.length == 0 && editor && (
        <div className="flex flex-col justify-center items-center">
          <div className="items-left">
            <div className="text-2xl font-bold">Build Your Form</div>
            <div>Drag and Drop components below to start designing. Use The preview to test your form. </div>
          </div>
        </div>
      )}
      {props.children && props.children.length == 0 && <AddChildItem xpath={props.xpath}></AddChildItem>}

      {props.children &&
        props.children.map((child: any, index: number) => {
          return (
            <React.Fragment key={"maindiv-" + index}>
              <RenderUiFromSpec
                {...props}
                key={index}
                item={child}
                xpath={props.xpath + '.' + index}
                children={child.children}
                form={props.form}
                inputSize={props.inputSize}
                index={0}
                title={''}
                className={undefined}
              />

              <AddChildItem xpath={props.xpath} index={index}></AddChildItem>
            </React.Fragment>
          )
        })}
    </div>
  )
}


export const RenderFormMain = (props: any) => {

  return (
    <>
      <div className={clsx(!props.item.title && !props.item.description ? 'hidden' : 'block')}>
        <h2 className="text-lg font-semibold">{props.item.title}</h2>
        <p className="text-sm text-gray-600 mb-4">{props.item.description}</p>
      </div>
      {props.children.map((child: any, index: number) => (
        <RenderUiFromSpec
          {...props}
          form={props.form}
          key={`${props.xpath}.${index}`}
          item={child}
          xpath={`${props.xpath}.${index}`}
          inputSize={props.inputSize}
          index={0}
          title=""
          className="my-4"
        >
          {child.children}
        </RenderUiFromSpec>
      ))}
    </>
  );
};

